import { render, staticRenderFns } from "./ProductFormView.vue?vue&type=template&id=5ab2ed4b&scoped=true"
import script from "./ProductFormView.vue?vue&type=script&lang=ts"
export * from "./ProductFormView.vue?vue&type=script&lang=ts"
import style0 from "./ProductFormView.vue?vue&type=style&index=0&id=5ab2ed4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2ed4b",
  null
  
)

export default component.exports